import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-bonus-info",
  templateUrl: "./bonus-info.component.html",
  styleUrls: ["./bonus-info.component.scss"],
})
export class BonusInfoComponent implements OnInit {
  private instructions = [
    {
      number: 1,
      instruction: "Purchase the Premium Bonus to get extra coins daily!",
      images: ["tresurechest"],
    },
    {
      number: 2,
      instruction: "Collect your coins daily!",
      images: ["premiumcoin1"],
    },
    {
      number: 3,
      instruction: "Make sure to login every day, don’t miss a collection!",
      images: ["day1", "day2", "day3"],
    },
  ];
  private basePath = "./../../../assets/shop/";
  constructor() {}

  ngOnInit() {}
}
